import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IDialogState, IToast, IUiState, RightPanel } from '@platform/core/types';

const initialState: IUiState = { leftMenuCollapsed: false, rightPanel: null, selection: {}, dialog: { kind: null }, toasts: [] };

/** Стан інтерфейсу, що не належить серверу: панелі, вибір, діалоги, повідомлення. */
export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    leftMenuToggled(state) { state.leftMenuCollapsed = !state.leftMenuCollapsed; },
    rightPanelChanged(state, action: PayloadAction<RightPanel>) { state.rightPanel = action.payload; },
    selectionChanged(state, action: PayloadAction<{ recordType: string; ids: string[] }>) {
      state.selection[action.payload.recordType] = action.payload.ids;
    },
    selectionCleared(state, action: PayloadAction<string>) { delete state.selection[action.payload]; },
    dialogOpened(state, action: PayloadAction<IDialogState>) { state.dialog = action.payload; },
    dialogClosed(state) { state.dialog = { kind: null }; },
    toastShown(state, action: PayloadAction<Omit<IToast, 'id'>>) {
      state.toasts.push({ id: `${Date.now()}-${state.toasts.length}`, ...action.payload });
      if (state.toasts.length > 5) state.toasts.shift();
    },
    toastDismissed(state, action: PayloadAction<string>) { state.toasts = state.toasts.filter((t) => t.id !== action.payload); },
  },
});

export const { leftMenuToggled, rightPanelChanged, selectionChanged, selectionCleared, dialogOpened, dialogClosed, toastShown, toastDismissed } = uiSlice.actions;
